
let currentSalesUnitId;
let isUpdating = false;
let previouslySelectedRow = null;

// =================================================================================
// GLOBALE HILFSFUNKTIONEN
// Logik für Preisberechnung, Modals und UI-Interaktionen
// =================================================================================


const loadReko = async () => {
  // Elemente holen
  const modalContainer = document.getElementById('fwModalContainer');
  const loader = document.getElementById('fwModalLoader');
  const content = document.getElementById('fwModalContent');

  // Modal öffnen & Body sperren
  document.body.style.overflow = 'hidden';
  modalContainer.style.display = 'block';
  
  // Loader kurz anzeigen (für UI-Konsistenz), Inhalt leeren
  loader.style.display = 'block';
  content.innerHTML = '';

  try {
    // Hier ist der HTML-Inhalt (Variante B - Zusammenfassung)
    // Du kannst hier auch noch ein <img> Tag oben einfügen, wenn du ein Bild hast.
    const htmlContent = `
      <div style="text-align: left; padding: 0 10px;">
        <h2 style="margin-bottom: 15px;">🛡️ Das Fasswulf-Qualitätsversprechen</h2>
        
        <p>Wir verkaufen keine einfach „ausgespülten“ Behälter. Dieser IBC wurde in unserer zertifizierten Anlage professionell aufbereitet:</p>
        
        <ul style="margin-bottom: 20px; line-height: 1.6;">
          <li><strong>🚿 400 Bar Hochdruck-Reinigung:</strong><br>Rückstandsfreie Entfernung von Anhaftungen mittels Hochdruck und Destillat.</li>
          
          <li style="margin-top: 10px;"><strong>✅ Geprüfte Dichtheit:</strong><br>Keine Leckagen dank maschineller Druckprüfung.</li>
          
          <li style="margin-top: 10px;"><strong>🔒 Sicher versiegelt:</strong><br>Der Auslaufhahn erhält eine <u>neue Siegelfolie</u>. Das garantiert Ihnen: Dieser Hahn wurde nach der Prüfung nicht mehr geöffnet.</li>
          
          <li style="margin-top: 10px;"><strong>🏷️ Dokumentiert:</strong><br>Unser Prüfaufkleber bestätigt den einwandfreien Zustand.</li>
        </ul>

        <div style="background-color: #f4f4f4; padding: 15px; border-radius: 5px; margin-bottom: 20px;">
          <strong>Fazit:</strong> Geprüfte Sicherheit, technisch und optisch einwandfrei.
        </div>

        <a href="/pages/ibc-rekonditionierung" class="btn btn--secondary" style="width: 100%; text-align: center;">zum kompletten Prozess</a>
      </div>
    `;

    // Kurze Verzögerung simulieren (optional, wirkt oft flüssiger) oder direkt rendern
    setTimeout(() => {
      content.innerHTML = htmlContent;
      loader.style.display = 'none';
      fwLog("Rekonditionierungs-Info geladen");
    }, 200);

  } catch (error) {
    console.error('Fehler beim Laden der Rekonditionierungs-Info:', error);
    content.innerHTML = '<p>Fehler beim Laden der Informationen.</p>';
    loader.style.display = 'none';
  }
};


/**
 * Zeigt ein Modal mit einer benutzerdefinierten Nachricht und Buttons an.
 */
function showFwModal(message) {
    const loader = document.getElementById('fwModalLoader');
    const content = document.getElementById('fwModalContent');
    const modal = document.getElementById('fwModalContainer');
    if (content && modal) {
        if (loader) {
            loader.style.display = 'none';
        }
        content.innerHTML = ` <div style="text-align: center;"><span style="color: red; font-size: 30px !important;">&#x26A0;</span><p style="margin-top: 0.5rem; margin-bottom: 1rem;">${message}</p>
                                <p style="margin-top: 0.5rem; margin-bottom: 1rem;">Sollten Sie größere Mengen benötigen oder möchten Sie eine Lieferzeitanfrage stellen, dann können Sie das hier direkt tun:</p>
                                <button class="button btn btn--primary" onclick="fwOpenProductRequestForm('Produktanfrage')">Großmengenanfrage</button>
                                <button class="button btn btn--primary" onclick="fwOpenProductRequestForm('Lieferzeitanfrage')">Lieferzeitanfrage</button>
                                <br>
                                <p style="margin-top: 2rem; margin-bottom: 1rem;">oder&nbsp;&nbsp;<button class="button btn btn--secondary" onclick="closeModal()">Schließen</button></p>             
                              </div>`;
        document.body.style.overflow = 'hidden';
        modal.style.display = 'block';
    }
}

/**
 * Formatiert eine Zahl in Cents in ein deutsches Währungsformat (z.B. 12345 -> "123,45 €").
 */
function formatCurrency(amount) {
    if (typeof amount !== 'number') return '0,00 €';
    return (amount / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
}


/**
 * Erzeugt eine "entprellte" (debounced) Funktion, die erst nach einer bestimmten
 * Wartezeit ohne erneuten Aufruf ausgeführt wird. Verhindert Performance-Probleme.
 */
function debounce(func, delay) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
    };
}



/**
 * Berechnet den Preis für eine gegebene Menge basierend auf den Staffelpreisen.
 */
function calculatePriceForQuantity(quantity) {
    const data = window.fwProductData;
    quantity = parseInt(quantity, 10);

    // --- ANGEPASSTE LOGIK ---
    // Wenn die Menge ungültig oder 0 ist, berechne stattdessen den Preis für 1 Stück.
    if (isNaN(quantity) || quantity <= 0) {
        quantity = 1;
    }
    // --- ENDE DER ANPASSUNG ---

    let itemPriceNet = 0;
    const sortedPrices = data.bulkPrices.sort((a, b) => a.qty - b.qty);
    for (const tier of sortedPrices) {
        if (quantity >= tier.qty) {
            itemPriceNet = tier.priceNet * 100;
        }
    }
    const totalWeightKg = data.weightPerItemKg * quantity;
    let shippingCostNet = 0;
    for (const rule of data.shippingRules) {
        if (totalWeightKg > rule.minWeight && totalWeightKg <= rule.maxWeight) {
            shippingCostNet = rule.priceNet * 100;
            break;
        }
    }
    const productTotalNet = itemPriceNet * quantity;
    const grandTotalNet = productTotalNet + shippingCostNet;
    const grandTotalGross = grandTotalNet * (1 + data.taxRate);
    return { net: grandTotalNet, gross: grandTotalGross, shipping: shippingCostNet };
}


/**
 * OPTIMIERT: Hebt die passende Zeile hervor, indem sie sich die
 * vorherige Zeile merkt und nur bei Bedarf Änderungen vornimmt.
 */
function updateSelectedRow(currentQuantity) {

    if (isNaN(currentQuantity)) return;

    const priceTableRows = document.querySelectorAll('.fwBulkPriceTable2025 tr[data-fw-quantity]');
    let bestMatchRow = null;

    // Schritt 1: Finde die neue, passende Zeile (dieser Teil ist schnell)
    priceTableRows.forEach(row => {
        const rowQty = parseInt(row.dataset.fwQuantity, 10);
        if (!isNaN(rowQty) && currentQuantity >= rowQty) {
            bestMatchRow = row; // Merke dir die letzte passende Zeile
        }
    });

    // Schritt 2: Führe DOM-Änderungen nur dann aus, wenn sich die Auswahl tatsächlich ändert
    if (bestMatchRow !== previouslySelectedRow) {
        fwLog('debug', 'Ausgewählte Zeile hat sich geändert. Aktualisiere Anzeige.');

        // Entferne die Klasse nur von der alten Zeile (falls vorhanden)
        if (previouslySelectedRow) {
            previouslySelectedRow.classList.remove('selected-row');
        }

        // Füge die Klasse nur zur neuen Zeile hinzu (falls vorhanden)
        if (bestMatchRow) {
            bestMatchRow.classList.add('selected-row');
        }

        // Merke dir die neue Zeile für den nächsten Durchlauf
        previouslySelectedRow = bestMatchRow;
    }
}

/**
 * OPTIMIERT: Schreibt nur noch die übergebenen Preise in die entsprechenden DOM-Elemente.
 * Liest oder berechnet selbst nichts mehr.
 * @param {number} productTotalNet - Der Nettopreis des Produkts (in Cent).
 * @param {number} productTotalGross - Der Bruttopreis des Produkts (in Cent).
 * @param {number} totalNetShipping - Der Netto-Gesamtpreis inkl. Versand (in Cent).
 * @param {number} totalGrossShipping - Der Brutto-Gesamtpreis inkl. Versand (in Cent).
 */
function updateDisplayedPrice(productTotalNet, productTotalGross, totalNetShipping, totalGrossShipping) {
    fwLog('--- Preis-Anzeige wird aktualisiert (updateDisplayedPrice) ---');

    // 1. Haupt-Preisanzeige aktualisieren
    const currentPriceElement = document.querySelector('.price__current');
    const grossPriceElement = document.querySelector('.price__gross');

    if (currentPriceElement && grossPriceElement) {
        currentPriceElement.textContent = formatCurrency(productTotalNet);
        grossPriceElement.textContent = formatCurrency(productTotalGross);
    }

    // 2. Untere Preis-Zusammenfassung aktualisieren
    document.getElementById('fwPriceTotalNet').textContent = formatCurrency(productTotalNet);
    document.getElementById('fwPriceTotalGross').textContent = formatCurrency(productTotalGross);
    document.getElementById('fwPriceTotalNetShipping').textContent = formatCurrency(totalNetShipping);
    document.getElementById('fwPriceTotalGrossShipping').textContent = formatCurrency(totalGrossShipping);

    fwLog('--- Preis-Anzeige Aktualisierung beendet ---');
}


/**
 * OPTIMIERT: Schreibt nur noch die Textbeschreibung für den Preis.
 * Erhält die benötigten Daten als Parameter.
 * @param {number} currentQuantity - Die aktuelle Gesamtmenge in der Basiseinheit.
 * @param {object} selectedUnit - Das Objekt der aktuell gewählten Verkaufseinheit.
 */
function updatePriceUnitDescriptor(currentQuantity, selectedUnit) {
    const netDescriptor = document.getElementById('price-unit-descriptor-net');
    const grossDescriptor = document.getElementById('price-unit-descriptor-gross');
    if (!netDescriptor || !grossDescriptor) return;

    if (window.hasSalesUnits && selectedUnit) {
        // --- LOGIK FÜR PRODUKTE MIT SALESUNITS ---
        if (currentQuantity > 0 && selectedUnit.content > 0) {
            const displayQuantity = currentQuantity / selectedUnit.content;
            let unitName = selectedUnit.type;
            if (displayQuantity !== 1) { // Plural-Logik
                if (unitName === 'Karton') unitName = 'Kartons';
                else if (unitName === 'Packung') unitName = 'Packungen';
            }
            const newText = `Preis für ${displayQuantity} ${unitName}`;
            netDescriptor.textContent = newText;
            grossDescriptor.textContent = newText;
        }
    } else {
        // --- LOGIK FÜR PRODUKTE OHNE SALESUNITS ---
        let newText;
        if (currentQuantity <= 1) {
            newText = 'Einzelpreis';
        } else {
            newText = `Preis für ${currentQuantity} Stück`;
        }
        netDescriptor.textContent = newText;
        grossDescriptor.textContent = newText;
    }
}


/**
 * Liest den Basis-Produktpreis aus dem 'data-base-price'-Attribut.
 * Dieses Vorgehen entkoppelt die Preisanzeige vom tatsächlichen Wert.
 */
function getProductPrice() {
    const priceElement = document.querySelector('.price__current');
    
    // Prüft, ob das Element und das data-base-price Attribut existieren
    if (priceElement && priceElement.dataset.basePrice) {
        // Liest den Wert aus 'data-base-price' und wandelt ihn in eine Zahl um
        const price = parseFloat(priceElement.dataset.basePrice);
        fwLog('Basis-Produktpreis aus data-base-price gelesen:', price);
        return price;
    }
    
    fwLog('Fehler: Kein .price__current Element mit data-base-price Attribut gefunden.');
    return null;
}

/**
 * Speichert die Warenkorbmengen im LocalStorage.
 */
function updateCartInventoryCache(cartItems) {
    const inventoryMap = cartItems.reduce((acc, item) => {
        acc[item.variant_id] = (acc[item.variant_id] || 0) + item.quantity;
        return acc;
    }, {});
    localStorage.setItem('fwCartInventory', JSON.stringify(inventoryMap));
}


/**
 * Überprüft die erlaubte Bestellmenge und passt den "In den Warenkorb"-Button an.
 */
// Globaler Cache für Inventardaten (verhindert ständiges JSON.parse)
let _fwInventoryCache = null;

/**
 * Prüft Warenkorbmenge.
 * @param {string} type - Der Kontext (z.B. 'Load').
 * @param {object|null} providedCart - Optional: Das Cart-Objekt aus dem Event (spart den Fetch!).
 */
function checkCartQuantity(type, providedCart = null) {
    // Wenn Button disabled ist & wir nur initial laden, raus hier (Performance)
    const addToCartButton = document.querySelector('#fwPDPMainBuyBtn');
    if (type === 'Load' && addToCartButton && addToCartButton.disabled) {
        return;
    }

    fwLog('Überprüfe die Menge der Variante im Warenkorb...');

    // Variant ID holen
    const currentVariantId = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    if (!currentVariantId) {
        return;
    }

    // --- SCHRITT 1: Maximalmenge ermitteln (mit Caching) ---
    let maxOrderQuantity = window.maxOrderQuantity || 10;

    // JSON nur beim ersten Mal parsen
    if (!_fwInventoryCache) {
        const inventoryScript = Array.from(document.querySelectorAll('script[type="application/json"]'))
            .find(s => s.textContent.includes('"inventory_quantity"'));
        
        if (inventoryScript) {
            try {
                _fwInventoryCache = JSON.parse(inventoryScript.textContent);
            } catch (e) { console.error(e); }
        }
    }

    if (_fwInventoryCache) {
        const variantInventory = _fwInventoryCache.find(v => String(v.id) === currentVariantId);
        if (variantInventory && variantInventory.inventory_quantity < maxOrderQuantity) {
            maxOrderQuantity = variantInventory.inventory_quantity;
        }
    }

    // --- SCHRITT 2: Verarbeitungslogik (DRY) ---
    const processCartData = (items) => {
        if (typeof updateCartInventoryCache === 'function') {
            updateCartInventoryCache(items);
        }

        const totalQuantity = items.reduce((sum, item) => (String(item.variant_id) === currentVariantId) ? sum + item.quantity : sum, 0);
        const remainingQuantity = Math.max(0, maxOrderQuantity - totalQuantity);
        
        fwLog('Verbleibend:', remainingQuantity);

        // Inputfeld begrenzen
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
            quantityInput.max = remainingQuantity;
        }

        // Button steuern
        if (addToCartButton) {
            const productPrice = typeof getProductPrice === 'function' ? getProductPrice() : 1;
            
            if (remainingQuantity <= 0 || productPrice === 0) {
                addToCartButton.disabled = true;
                addToCartButton.classList.add('disabled');
                addToCartButton.textContent = (productPrice === 0) ? 'Nicht verfügbar' : 'Maximum erreicht';
            } else {
                addToCartButton.disabled = false;
                addToCartButton.classList.remove('disabled');
                addToCartButton.textContent = 'In den Warenkorb';
            }
        }
    };

    // --- SCHRITT 3: Datenquelle wählen ---
    // HIER IST DER TRICK: Wenn providedCart da ist, nutzen wir es. Sonst fetch.
    if (providedCart && providedCart.items) {
        fwLog('Nutze Event-Daten (Kein Fetch).');
        processCartData(providedCart.items);
    } else {
        fwLog('Hole Daten vom Server (Fetch).');
        fetch('/cart.js')
            .then(res => res.ok ? res.json() : Promise.reject(res.status))
            .then(cart => processCartData(cart.items))
            .catch(e => console.error(e));
    }
}

/**
 * Prüft eine gegebene Menge und gibt die nächstkleinere, gültige Staffelmenge zurück.
 */
function getValidTierQuantity(quantity) {
    const data = window.fwProductData;
    if (!data || !data.bulkPrices || !Array.isArray(data.bulkPrices) || data.bulkPrices.length === 0) {
        return 1; // Fallback
    }

    const validTiers = data.bulkPrices.map(p => p.qty).sort((a, b) => a - b);
    let bestMatch = validTiers[0] || 1;

    for (const tierQty of validTiers) {
        if (quantity >= tierQty) {
            bestMatch = tierQty;
        } else {
            break;
        }
    }
    return bestMatch;
}


/**
 * Aktualisiert den visuellen "is-active"-Zustand der Verkaufseinheit-Buttons.
 * @param {number} activeUnitId - Die ID der Einheit, die aktiv sein soll.
 */
function updateActiveUnitButton(activeUnitId) {
    document.querySelectorAll('.unit-option').forEach(button => {
        // data-unit-id ist ein String, daher der Vergleich mit parseInt
        if (parseInt(button.dataset.unitId, 10) === activeUnitId) {
            button.classList.add('is-active');
        } else {
            button.classList.remove('is-active');
        }
    });
}


/**
 * Liest den 'amount'-Parameter, validiert ihn und führt alle einmaligen
 * UI-Anpassungen für die Gebinde-Ansicht aus.
 */
function initializeQuantityFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const amountFromUrl = parseInt(urlParams.get('amount'), 10);
    const quantityInput = document.querySelector('.qty-input__input');
    const data = window.fwProductData;

    // Nur ausführen, wenn ein valider 'amount'-Parameter vorhanden ist.
    if (!isNaN(amountFromUrl) && amountFromUrl > 0 && data) {
        
        // NEU: Wir speichern den URL-Wert global für spätere Fallback-Logik (Google Price Mismatch Fix)
        window.fwUrlAmount = amountFromUrl;

        if (window.hasSalesUnits && data.salesUnits && data.salesUnits.length > 0) {
            
            // --- LOGIK FÜR PRODUKTE MIT SALESUNITS ---

            // 1. Finde die beste Verkaufseinheit für die gegebene Menge
            let bestUnitId = 1;
            const sortedUnits = [...data.salesUnits].sort((a, b) => b.content - a.content);
            for (const unit of sortedUnits) {
                if (amountFromUrl > 0 && amountFromUrl % unit.content === 0) {
                    bestUnitId = unit.id;
                    break;
                }
            }
            
            // 2. Setze die globalen Zustände
            currentSalesUnitId = bestUnitId;
            quantityInput.value = amountFromUrl;
            fwLog(`URL-Amount: ${amountFromUrl}. Beste Einheit gefunden: ID ${bestUnitId}`);

            // 3. UI-Anpassungen
            updateActiveUnitButton(bestUnitId);

            // SKU anpassen (Logik aus alter Funktion übernommen)
            const skuElement = document.querySelector('.product-sku__value');
            if (skuElement) {
                const baseSku = skuElement.textContent.trim();
                skuElement.textContent = `${baseSku}-${amountFromUrl}`;
            }

        } else {
            
            // --- LOGIK FÜR PRODUKTE OHNE SALESUNITS (aus alter Funktion) ---

            // 1. Validiere die Menge und springe ggf. auf die zweite Staffel hoch
            let validQuantity = getValidTierQuantity(amountFromUrl);
            const validTiers = data.bulkPrices.map(p => p.qty).sort((a, b) => a - b);
            if (validTiers.length >= 2 && validQuantity < validTiers[1]) {
                validQuantity = validTiers[1];
            }
            quantityInput.value = validQuantity;

            // 2. UI-Anpassungen
            const skuElement = document.querySelector('.product-sku__value');
            if (skuElement) {
                const baseSku = skuElement.textContent.trim();
                skuElement.textContent = `${baseSku}-${validQuantity}`;
            }
            
            // 3. URL aufräumen, falls die Menge angepasst wurde
            if (validQuantity !== amountFromUrl) {
                urlParams.set('amount', validQuantity);
                const newUrl = `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
                history.replaceState({}, '', newUrl);
            }
        }
    }
}




function updatePriceTable(selectedUnit) {

    fwLog('--- updatePriceTable() wird ausgeführt mit Einheit:', selectedUnit);

    const priceTable = document.querySelector('.fwBulkPriceTable2025');
    if (!priceTable) {
        return;
    }

    const priceTableRows = priceTable.querySelectorAll('tr[data-fw-quantity]');
    
    priceTableRows.forEach(row => {

        const originalQuantity = parseInt(row.dataset.fwQuantity, 10);
        const conversionFactor = selectedUnit.content;
        
        if (isNaN(originalQuantity) || !conversionFactor) {
            fwLog('FEHLER: Ungültige Daten für diese Zeile.');
            fwLog(`--- Verarbeite Zeile mit Menge ${originalQuantity} ---`);
            fwLog(`Conversion Factor: ${conversionFactor}`);
            return;
        }

        const newQuantity = originalQuantity / conversionFactor;

        if (newQuantity < 0.99) {

            row.style.display = 'none';
        } else {

            row.style.display = 'table-row';
            
            const quantityCell = row.querySelector('td:first-child');
            if (quantityCell) {
                const displayQuantity = Math.round(newQuantity);
                let unitName = selectedUnit.type;

                    if (unitName === 'Packung') unitName = 'Pck.';
                    if (unitName === 'Stück') unitName = 'Stk.';
                    if (unitName === 'Karton') unitName = 'Ktn.';
                    if (unitName === 'Palette') unitName = 'Pal.';
              
                const newText = `${displayQuantity} ${unitName}`;
                quantityCell.textContent = newText;
            }
        }
    });
}


/**
 * FINAL: Aktualisiert ALLE drei Text-Anzeigen, die von der Menge und der Einheit abhängen.
 * Inklusive detailliertem Logging für die Fehlersuche.
 */
function updateSalesUnitDisplays(selectedUnit) {
    fwLog('--- updateSalesUnitDisplays() gestartet ---');
    fwLog('Empfangene Einheit:', selectedUnit);

    const quantityInput = document.querySelector('.qty-input__input');
    if (!quantityInput) {
        fwLog('FEHLER: quantityInput nicht gefunden.');
        return;
    }
    
    const totalQuantity = parseInt(quantityInput.value, 10) || 0;
    fwLog('Gelesene Gesamtmenge aus Input:', totalQuantity);

    // --- Gemeinsame Berechnungen ---
    const conversionFactor = selectedUnit.content > 0 ? selectedUnit.content : 1;
    const displayQuantity = totalQuantity / conversionFactor;

    // --- Text für Desktop-Ansicht (mit Plural) ---
    let unitNameDesktop = selectedUnit.type;
    if (displayQuantity !== 1) {
        if (unitNameDesktop === 'Karton') unitNameDesktop = 'Kartons';
        else if (unitNameDesktop === 'Packung') unitNameDesktop = 'Packungen';
        // Plural für Stück und Palette ist oft gleich, kann hier aber bei Bedarf ergänzt werden.
    }
    const newTextDesktop = `${displayQuantity} ${unitNameDesktop}`;

    // --- Text für Mobile-Ansicht (mit Abkürzungen) ---
    let unitNameMobile;
    switch (selectedUnit.type) {
        case 'Karton':
            unitNameMobile = 'Ktn.';
            break;
        case 'Packung':
            unitNameMobile = 'Pck.';
            break;
        case 'Stück':
            unitNameMobile = 'Stk.';
            break;
        case 'Palette':
            unitNameMobile = 'Plt.';
            break;
        default:
            // Fallback, falls die Einheit unbekannt ist
            unitNameMobile = selectedUnit.type;
    }
    const newTextMobile = `${displayQuantity} ${unitNameMobile}`;


    // --- Anzeige 1 (Desktop): Text in das Desktop-Element schreiben ---
    const displayElement = document.getElementById('contentInSalesUnits');
    if (displayElement) {
        fwLog(`Setze #contentInSalesUnits auf: "${newTextDesktop}"`);
        displayElement.textContent = newTextDesktop;
    } else {
        fwLog('Info: Element #contentInSalesUnits nicht gefunden.');
    }

    // --- Anzeige 1 (Mobile): Abgekürzten Text in das Mobile-Element schreiben ---
    const displayElementMobile = document.getElementById('contentInSalesUnitsMobile');
    if (displayElementMobile) {
        fwLog(`Setze #contentInSalesUnitsMobile auf: "${newTextMobile}"`);
        displayElementMobile.textContent = newTextMobile;
    } else {
        fwLog('Info: Element #contentInSalesUnitsMobile nicht gefunden.');
    }

    // --- Anzeige 2: Die Gesamt-Stückzahl (bleibt unverändert) ---
    const totalQuantityElement = document.getElementById('salesUnit');
    if (totalQuantityElement) {
        fwLog(`Setze #salesUnit auf: "${totalQuantity}"`);
        totalQuantityElement.textContent = totalQuantity;
    } else {
        fwLog('Info: Element #salesUnit nicht gefunden.');
    }
    
    fwLog('--- updateSalesUnitDisplays() beendet ---');
}

/**
 * Die ZENTRALE "Alles-Aktualisieren"-Funktion.
 * @param {boolean} isFullUpdate - Wenn true, wird auch die Tabelle neu gezeichnet (teuer).
 */
/**
 * FINAL & KORRIGIERT: Führt die Mengen-Validierung und Preisberechnung
 * wieder selbst durch und gibt die Ergebnisse an die Unterfunktionen weiter.
 */
/**
 * FINAL & KORRIGIERT: Führt die Mengen-Validierung und Preisberechnung
 * wieder selbst durch und gibt die Ergebnisse an die Unterfunktionen weiter.
 */
function handleQuantityChange(isFullUpdate = false) {
    if (isUpdating) return;
    isUpdating = true;
    fwLog('groupCollapsed', `--- handleQuantityChange() gestartet (FullUpdate: ${isFullUpdate}) ---`);

    try {
        const quantityInput = document.querySelector('.qty-input__input');
        if (!quantityInput) return;

        // 1. Lese den tatsächlichen Input-Wert (kann 0 sein)
        let inputValue = parseInt(quantityInput.value, 10);
        
        // 2. Bestimme die Menge, die für die PREIS-Berechnung genutzt wird (calculationQuantity)
        let calculationQuantity = inputValue;

        // --- GOOGLE MERCHANT CENTER FIX ---
        // Wenn Input <= 0 ist (z.B. ausverkauft), aber wir via URL (z.B. ?amount=40) kamen,
        // dann berechnen wir den Preis für 40, lassen das Input aber auf 0.
        if (isNaN(inputValue) || inputValue <= 0) {
            if (typeof window.fwUrlAmount !== 'undefined' && window.fwUrlAmount > 0) {
                calculationQuantity = window.fwUrlAmount;
                fwLog(`Input ist 0, aber URL-Amount ${calculationQuantity} wird für Preisberechnung genutzt.`);
            } else {
                calculationQuantity = 1; // Standard-Fallback
            }
        }
        // --- ENDE FIX ---

        // 3. Validierung der MAXIMALEN Bestellmenge (Nur wenn Input > 0 ist, wollen wir korrigieren)
        // Wenn Input 0 ist (Ausverkauft-Szenario), korrigieren wir NICHT, damit 0 stehen bleibt.
        const maxQuantity = parseInt(quantityInput.max, 10);
        
        if (inputValue > 0 && !isNaN(maxQuantity) && inputValue > maxQuantity) {
            let correctedQuantity = maxQuantity;
            if (window.hasSalesUnits) {
                const selectedUnit = fwProductData.salesUnits.find(unit => unit.id === currentSalesUnitId);
                if (selectedUnit && selectedUnit.content > 0) {
                    correctedQuantity = Math.floor(maxQuantity / selectedUnit.content) * selectedUnit.content;
                }
            }
            
            // Nur korrigieren und neu starten, wenn der Wert sich tatsächlich ändert
            if (inputValue != correctedQuantity) {
                 quantityInput.value = correctedQuantity;
                 showFwModal(`Die maximale Bestellmenge beträgt ${maxQuantity} Stück. Ihre Eingabe wurde auf ${correctedQuantity} Stück korrigiert.`);
                 setTimeout(() => handleQuantityChange(isFullUpdate), 0);
                 return;
            }
            // Wenn korrigiert wurde, ist calculationQuantity nun der korrigierte Wert
            calculationQuantity = correctedQuantity;
        }

        // Preisberechnung findet jetzt mit der calculationQuantity statt
        const prices = calculatePriceForQuantity(calculationQuantity);
        const productTotalNet = prices.net - prices.shipping;
        const productTotalGross = productTotalNet * (1 + fwProductData.taxRate);
        
        // UI Updates mit der calculationQuantity aufrufen
        if (window.hasSalesUnits) {
            const selectedUnit = fwProductData.salesUnits.find(unit => unit.id === currentSalesUnitId);
            if (selectedUnit) {
                if (isFullUpdate) {
                    updatePriceTable(selectedUnit);
                }
                // HIER WICHTIG: updateSalesUnitDisplays nutzt intern das DOM-Element. 
                // Da das Input 0 ist, würde hier "0 Packungen" stehen. 
                // Für den Preis-Text (price-unit-descriptor) nutzen wir calculationQuantity.
                updatePriceUnitDescriptor(calculationQuantity, selectedUnit);
                
                // Optional: Wenn Sie wollen, dass auch "40 Stück = 2 Packungen" angezeigt wird, 
                // obwohl Input 0 ist, müssten Sie updateSalesUnitDisplays umbauen. 
                // Standardmäßig liest es den Input aus. Wir lassen das hier so, 
                // damit der Kunde sieht "Input ist 0".
                updateSalesUnitDisplays(selectedUnit); 
            }
        } else {
            updatePriceUnitDescriptor(calculationQuantity, null);
        }
        
        // WICHTIG: Tabelle und Preise basierend auf der URL-Menge (40) aktualisieren
        updateSelectedRow(calculationQuantity);
        updateDisplayedPrice(productTotalNet, productTotalGross, prices.net, prices.gross);

    } finally {
        isUpdating = false;
        fwLog('groupEnd');
    }
}



/**
 * Überprüft den 'price' URL-Parameter und passt die Steuerpräferenz an.
 * Akzeptiert "gross" für Brutto- und "net" für Nettopreise.
 */
function handlePriceURLParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const pricePreference = urlParams.get('price'); // Holt den Wert des 'price'-Parameters

    if (pricePreference === 'gross') {
        // Wenn der Parameter 'gross' ist, setze die Anzeige auf Brutto
        localStorage.setItem('ls_pricesWithTax', '1');
        fwSetTaxPreference();

        fwLog("URL-Parameter 'price=gross' erkannt. Preise werden als Brutto angezeigt.");

        const taxToggle = document.getElementById('fwTaxToggle');
        if (typeof pricesWithTax === 'function') {
            const currentTaxValue = taxToggle ? (taxToggle.checked ? 1 : 0) : 0;
            pricesWithTax(currentTaxValue);
        }

    } 

}


/* ============================================================
 * PDP-Produktanfrage über das geteilte Anfrage-Popup
 * (window.fwAnfrageModal aus assets/fw__js-anfrage-modal.js).
 * Ersetzt das frühere Shopify-Forms-App-Modal. Das angefragte
 * Produkt wird in einer eigenen LS-Liste 'fwPdpAnfrage' gehalten,
 * getrennt von der B2B-Anfrageliste 'fwB2bAnfrageliste'.
 * ============================================================ */

const FW_PDP_ANFRAGE_KEY = 'fwPdpAnfrage';

// Liest das aktuell gewählte Produkt aus den #pdpAddWishlist-data-attributes
// (vom on:variant:change-Listener in fw__css-base.js stets aktuell gehalten)
// plus Menge aus dem Mengen-Input. Format kompatibel zur B2B-Anfrageliste.
function fwPdpReadProductItem() {
  const el = document.getElementById('pdpAddWishlist');
  if (!el) return null;
  const productId = el.dataset.productId;
  const qtyInput = (productId && document.querySelector(`.qty-input__input[data-product-id='${productId}']`))
    || document.querySelector('input.qty-input__input');
  const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  return {
    variantId:        el.dataset.variantId,
    sku:              el.dataset.sku || '',
    qty:              qty,
    step:             1,
    productTitle:     el.dataset.productTitle || '',
    variantTitle:     el.dataset.variantTitle || '',
    variantLabel:     el.dataset.variantLabel || el.dataset.variantTitle || '',
    image:            el.dataset.image || '',
    priceCents:       parseInt(el.dataset.priceCents, 10) || 0,
    isFree:           false,
    offerAlternative: false
  };
}

function fwPdpGetAnfrage() {
  try { return JSON.parse(localStorage.getItem(FW_PDP_ANFRAGE_KEY) || 'null'); }
  catch (e) { return null; }
}

function fwPdpClearAnfrage() {
  localStorage.removeItem(FW_PDP_ANFRAGE_KEY);
}

// Schreibt das aktuelle Produkt frisch in die PDP-Anfrageliste + DataLayer-Event.
function fwPdpWriteAnfrage(subject) {
  const item = fwPdpReadProductItem();
  if (!item) return null;
  const payload = { subject: subject, item: item };
  localStorage.setItem(FW_PDP_ANFRAGE_KEY, JSON.stringify(payload));
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pdp_request_product_added',
    subject: subject,
    variant_id: item.variantId,
    sku: item.sku,
    product_title: item.productTitle,
    quantity: item.qty,
    price: item.priceCents / 100
  });
  return payload;
}

// "Weitere Artikel hinzufügen": Produkt in die B2B-Anfrageliste übernehmen
// und auf die B2B-Collection-Seite weiterleiten.
function fwPdpAddMoreToB2b() {
  const p = fwPdpGetAnfrage();
  const item = p && p.item;
  if (item && typeof fwAnfrageAdd === 'function') {
    fwAnfrageAdd({
      variantId:    item.variantId,
      sku:          item.sku,
      qty:          item.qty,
      step:         item.step,
      productTitle: item.productTitle,
      variantTitle: item.variantTitle,
      variantLabel: item.variantLabel,
      image:        item.image,
      priceCents:   item.priceCents,
      source:       'pdp'
    });
  }
  fwPdpClearAnfrage();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pdp_request_add_more',
    variant_id: item ? item.variantId : null
  });
  window.location.href = '/collections/b2b';
}

// Öffnet das geteilte Anfrage-Popup im PDP-Modus.
function fwPdpOpenAnfrageModal(subject) {
  const subj = subject || 'Produktanfrage';
  const payload = fwPdpWriteAnfrage(subj);
  if (!payload) { console.error('PDP-Anfrage: #pdpAddWishlist nicht gefunden'); return; }
  if (!window.fwAnfrageModal) { console.error('fwAnfrageModal-Modul nicht geladen'); return; }
  const title = (subj === 'Lieferzeitanfrage') ? 'Lieferzeitanfrage' : 'Produktanfrage';
  window.fwAnfrageModal.open({
    mode: 'pdp',
    subject: subj,
    title: title,
    getItems: () => { const p = fwPdpGetAnfrage(); return (p && p.item) ? [p.item] : []; },
    updateItem: (variantId, patch) => {
      const p = fwPdpGetAnfrage();
      if (!p || !p.item || String(p.item.variantId) !== String(variantId)) return;
      Object.assign(p.item, patch);
      localStorage.setItem(FW_PDP_ANFRAGE_KEY, JSON.stringify(p));
    },
    onSuccess: fwPdpClearAnfrage,
    showAddMore: true,
    onAddMore: fwPdpAddMoreToB2b
  });
}

/**
 * Öffnet das Produktanfrageformular.
 */
function fwOpenProductRequestForm(subject) {
    // Wird per inline onclick aus dem Error-Modal (showFwModal) aufgerufen.
    // Error-Modal schließen, dann das geteilte Anfrage-Popup öffnen.
    if (typeof closeModal === 'function') closeModal();
    fwPdpOpenAnfrageModal(subject || 'Produktanfrage');
}


function fwRenderBreadcrumbCollection() {
    if (!document.referrer.includes('/collections/')) return;
    const coll = localStorage.getItem('fwLastCollection');
    if (!coll) return;
    const el = document.querySelector('.fwDynamicCollection a');
    if (!el) return;

    el.href = `/collections/${coll}`;
    el.textContent = coll
        .replace(/-/g, ' ')
        .replace(/ae/g, 'ä').replace(/oe/g, 'ö').replace(/ue/g, 'ü')
        .split(' ').map(word => word.toLowerCase().startsWith('ibc') ? 'IBC' + word.slice(3) : word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

function showAllPaymentMethods() {
    document.querySelectorAll('svg.payment-icon').forEach(icon => {
        const parentLi = icon.closest('li');
        if (parentLi) parentLi.classList.remove('hidden');
    });
}

/**
 * Lädt das Video nach bzw. ändert die Source
 */
function initializeLazyVideos() {
  // Alle Videos mit einem 'data-src'-Attribut finden
  const lazyVideos = [].slice.call(document.querySelectorAll("video[data-src]"));

  // Sicherstellen, dass der Browser den IntersectionObserver unterstützt
  if ("IntersectionObserver" in window) {
    // Einen Observer erstellen, der auf die Sichtbarkeit der Videos reagiert
    let lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(videoEntry) {
        // Wenn das Video in den sichtbaren Bereich kommt...
        if (videoEntry.isIntersecting) {
          const video = videoEntry.target;
          
          // 1. Die Videoquelle vom data-src in das src-Attribut kopieren
          video.src = video.dataset.src;
          
          // 2. Das Video laden, aber nicht sofort starten
          video.load();
          video.pause();
          
          // 3. Die Beobachtung für dieses Video beenden, da es geladen ist
          lazyVideoObserver.unobserve(video);
        }
      });
    });

    // Jedes gefundene "faule" Video dem Observer hinzufügen
    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
}

// =================================================================================
// INITIALISIERUNG & EVENT LISTENERS
// Wird ausgeführt, nachdem die Seite vollständig geladen ist.
// =================================================================================

document.addEventListener('DOMContentLoaded', function () {

    fwLog('Seite geladen - Start der Initialisierung.');

    // --- Setup: Elemente der Produktseite ---
    const data = window.fwProductData;
    const quantityInput = document.querySelector('.qty-input__input');
    const shippingToggle = document.getElementById('fwShippingToggle');
    const plusButton = document.querySelector('.qty-input__btn[name="plus"]');
    const minusButton = document.querySelector('.qty-input__btn[name="minus"]');
    const priceTableRows = document.querySelectorAll('.fwBulkPriceTable2025 tr');
    const storageKeyShipping = 'lsShowPricesInclShipping';

    if (!data || !quantityInput) {
        console.error("FW Price Calculator: Wichtige Daten oder das Mengenfeld fehlen.");
        // Hier nicht abbrechen, damit andere Skriptteile noch laufen können.
    }
    
    // --- Preisrechner Event Listeners ---
    if (shippingToggle) {

        // --- KORREKTUR: Standardwert zurück auf 'false' (exkl. Versand) ---
        // Der Schalter ist jetzt standardmäßig AUS, es sei denn, der Nutzer hat ihn explizit eingeschaltet.
        shippingToggle.checked = localStorage.getItem(storageKeyShipping) === 'true';

        // Event-Listener für zukünftige Änderungen (bleibt gleich)
        shippingToggle.addEventListener('change', function () {
            localStorage.setItem(storageKeyShipping, this.checked);
            
            // Führe die Preis-Aktualisierung aus
            const taxToggle = document.getElementById('fwTaxToggle');
            const currentTaxValue = taxToggle ? (taxToggle.checked ? 1 : 0) : 0;
            if (typeof pricesWithTax === 'function') {
                pricesWithTax(currentTaxValue);
            }
            if(typeof showToastNotification === 'function') showToastNotification("Einstellung gespeichert");
        });

        // --- KORREKTUR 2: Führe die Preis-Aktualisierung EINMALIG beim Seitenladen aus ---
        // Dieser Block wendet den gerade gesetzten Zustand (aus localStorage oder den neuen Default) sofort an.
        const initialTaxToggle = document.getElementById('fwTaxToggle');
        const initialTaxValue = initialTaxToggle ? (initialTaxToggle.checked ? 1 : 0) : 0;
        if (typeof pricesWithTax === 'function') {
            fwLog('Wende initiale Versandkosten-Präferenz an...');
            pricesWithTax(initialTaxValue);
        }
    }

    priceTableRows.forEach(row => {
        row.addEventListener('click', function () {
            // --- NEUE PRÜFUNG ---
            // Wenn die geklickte Zeile bereits die 'selected-row'-Klasse hat,
            // brich die Funktion sofort ab, um unnötige Updates zu vermeiden.
            if (this.classList.contains('selected-row')) {
                return;
            }
            // --- ENDE DER PRÜFUNG ---

            // Der restliche Code wird nur ausgeführt, wenn die Zeile nicht aktiv war.
            const quantity = parseInt(this.dataset.fwQuantity, 10);
            if (!isNaN(quantity) && quantityInput) {
                quantityInput.value = quantity;
                handleQuantityChange(); // Leichtes Update
            }
        });
    });

    // Erstelle eine "entprellte" Version deines Managers mit einer Wartezeit von 250ms
    const debouncedHandleQuantityChange = debounce(handleQuantityChange, 250);

    // Event-Listener für das Eingabefeld
    if (quantityInput) {
        // Verwende jetzt die entprellte Version für das 'input'-Event
        quantityInput.addEventListener('input', debouncedHandleQuantityChange);
    }

    if (plusButton) {
        plusButton.addEventListener('click', (e) => {
            e.stopImmediatePropagation(); 
            const quantityInput = document.querySelector('.qty-input__input');
            if (!quantityInput) return;

            let currentValue = parseInt(quantityInput.value, 10) || 0;
            let step;

            // --- NEUE UNTERSCHEIDUNG ---
            if (window.hasSalesUnits) {
                // Bei SalesUnit-Produkten: Schrittgröße aus der Einheit
                const selectedUnit = fwProductData.salesUnits.find(unit => unit.id === currentSalesUnitId);
                step = selectedUnit ? selectedUnit.content : 1;
            } else {
                // Bei normalen Produkten: Schrittgröße aus dem 'step'-Attribut des Inputs lesen
                step = parseInt(quantityInput.step, 10) || 1;
            }
            // --- ENDE DER NEUEN UNTERSCHEIDUNG ---
            
            quantityInput.value = currentValue + step;
            setTimeout(handleQuantityChange, 0);
        });
    }

    if (minusButton) {
        minusButton.addEventListener('click', (e) => {
            e.stopImmediatePropagation();
            const quantityInput = document.querySelector('.qty-input__input');
            if (!quantityInput) return;

            let currentValue = parseInt(quantityInput.value, 10) || 0;
            let step;
            let minValue;

            // --- NEUE UNTERSCHEIDUNG ---
            if (window.hasSalesUnits) {
                // Bei SalesUnit-Produkten: Schrittgröße und Minimum aus der Einheit
                const selectedUnit = fwProductData.salesUnits.find(unit => unit.id === currentSalesUnitId);
                if (selectedUnit) {
                    step = selectedUnit.content;
                    minValue = selectedUnit.content;
                } else {
                    step = 1;
                    minValue = 1;
                }
            } else {
                // Bei normalen Produkten: Werte aus den HTML-Attributen lesen
                step = parseInt(quantityInput.step, 10) || 1;
                minValue = parseInt(quantityInput.min, 10) || 1;
            }
            // --- ENDE DER NEUEN UNTERSCHEIDUNG ---

            const newValue = Math.max(minValue, currentValue - step);
            quantityInput.value = newValue;
            
            setTimeout(handleQuantityChange, 0);
        });
    }


    // --- Anfrage-Button Event Listeners ---
    // Öffnet das geteilte Anfrage-Popup (window.fwAnfrageModal). Betreff aus
    // data-subject: "Lieferzeitanfrage" (ausverkauft) bzw. "Produktanfrage".
    document.querySelectorAll('.fwPDPMainReqBtn').forEach((btn) => {
        btn.addEventListener('click', function () {
            fwPdpOpenAnfrageModal(btn.getAttribute('data-subject') || 'Produktanfrage');
        });
    });


    currentSalesUnitId = 1; 
    fwLog('DOM geladen. Start-Einheit ID:', currentSalesUnitId);

    const salesUnitContainer = document.querySelector('.sales-unit-options');

    // Hänge EINEN EINZIGEN Listener an diesen Container an
    if (salesUnitContainer) {
        salesUnitContainer.addEventListener('click', function(e) {
            // Finde den eigentlichen Button, der innerhalb des Containers geklickt wurde
            const button = e.target.closest('.unit-option');

            // Wenn nicht auf einen Button (oder dessen Inhalt) geklickt wurde, tu nichts
            if (!button) return;

            // Verhindere das Neuladen der Seite, da es ein Link ist
            e.preventDefault();
            fwLog('--- Klick-Event für Einheiten-Wechsel gestartet (via Delegation) ---');

            // Klassen für die aktive Ansicht umschalten
            const activeButton = document.querySelector('.unit-option.is-active');
            if (activeButton) {
                activeButton.classList.remove('is-active');
            }
            button.classList.add('is-active'); // Wichtig: 'this' wird durch 'button' ersetzt
            
            // Die ID der neuen Einheit speichern
            currentSalesUnitId = parseInt(button.dataset.unitId, 10); // 'this' wird durch 'button' ersetzt
            fwLog('Neue Einheit gewählt. ID:', currentSalesUnitId);

            // Die Aufrunden-Logik bleibt genau gleich
            const quantityInput = document.querySelector('.qty-input__input');
            const selectedUnit = fwProductData.salesUnits.find(unit => unit.id === currentSalesUnitId);

            if (quantityInput && selectedUnit && selectedUnit.content > 0) {
                let totalQuantity = parseInt(quantityInput.value, 10) || 0;
                let howManyUnitsNeeded = Math.ceil(totalQuantity / selectedUnit.content);
                if (howManyUnitsNeeded === 0) {
                    howManyUnitsNeeded = 1;
                }
                const newRoundedQuantity = howManyUnitsNeeded * selectedUnit.content;
                fwLog(`Menge wird aufgerundet: von ${totalQuantity} auf ${newRoundedQuantity}`);
                quantityInput.value = newRoundedQuantity;
            }

            // Rufe die zentrale Update-Funktion auf
            handleQuantityChange(true);
        });
    }


    // =================================================================================
    // EVENT LISTENER FÜR WARENKORB-UPDATES (KORRIGIERTE VERSION)
    // =================================================================================

    (function() {
        const mainProductVariantIds = window.mainProductVariantIds || [];

        // Hilfsfunktion: Prüft ID und öffnet Modal mit KORREKTER Menge
        const checkAndTriggerCrossSell = (variantId) => {
            if (variantId && mainProductVariantIds.includes(String(variantId))) {
                
                // 1. Die Menge direkt aus dem Haupt-Input lesen (Das ist "die gewählte Menge")
                const mainInput = document.querySelector('.qty-input__input');
                const quantitySelected = mainInput ? mainInput.value : 1;

                fwLog('✅ Cross-Sell Trigger. Gewählte Menge:', quantitySelected);

                const overlay = document.getElementById('fwCrosssellModal-overlay');
                const modal = document.getElementById('fwCrosssellModal');
                
                if (overlay && modal) {
                    setTimeout(() => {
                        overlay.classList.add('show');
                        modal.classList.add('show');
                        
                        // 2. Menge in alle Inputs im Modal schreiben
                        modal.querySelectorAll('input[name="quantity"]').forEach(input => {
                            input.value = quantitySelected; 
                        });
                    }, 300);
                }
            }
        };

        // 1. Listener: Neues Produkt wird hinzugefügt
        document.addEventListener('on:cart:add', (event) => {
            fwLog('Event on:cart:add', event.detail);
            
            // A) Cross-Sell prüfen (Menge wird intern geholt)
            checkAndTriggerCrossSell(event.detail.variantId);
            
            // B) Button & Mengen prüfen
            checkCartQuantity('Update', event.detail.cart); 
        });

        // 2. Listener: Menge eines existierenden Produkts wird erhöht
        document.addEventListener('on:line-item:change', (event) => {
            fwLog('Event on:line-item:change', event.detail);
            
            // A) Cross-Sell (nur bei Erhöhung der Menge)
            //if (event.detail.newQuantity > event.detail.oldQuantity) {
            //     checkAndTriggerCrossSell(event.detail.variantId);
            //}

            // B) Button & Mengen prüfen
            checkCartQuantity('Update', event.detail.cart);
        });

    })();

    // --- Initiale Funktionsaufrufe beim Seitenladen ---


    initializeQuantityFromUrl();
    handlePriceURLParameter();
    fwUpdateOfferSchema();
    checkCartQuantity('Load');
    fwRenderBreadcrumbCollection();
    initializeLazyVideos();
    handleQuantityChange(true);

});